import Vue from 'vue';
import VueAnimateNumber from 'vue-animate-number';

Vue.use(VueAnimateNumber);
